import { fromJS } from 'immutable'

export function mergeDeep(state, parameter) {
    var newState = fromJS(state)
    newState = newState.mergeDeep(parameter)
    return newState.toJS()
}

export function updateIn(state, parameter, fn) {
    var newState = fromJS(state);
    newState = newState.updateIn(parameter, p => fn(p))
    return newState.toJS();
}

export function setValue(state, parameter, value) {
    const original = fromJS(state)
    var original2 = original.setIn(parameter, value)
    return original2.toJS()
}
